const EVENTS = ['formCreated','beforeUpdate','beforeSave','userCreated',
    'newPasswordGenerated','storageItemBelowZero']
export default class EventActionType{

    static getEventName(event) {
        switch (event) {
            case "formCreated":
                return "Po utworzeniu formularza"
            case "beforeUpdate":
                return "Przed aktualizacja  formularza"
            case "beforeSave":
                return "Po zapisaniem formularza"
            case "userCreated":
                return "Po utworzeniu użytkownika"
            case "newPasswordGenerated":
                return "Po wygenerowaniu nowego hasła dla użytkownika"
            case "storageItemBelowZero":
                return "Gdy ilość sztuk na magazynie spadnie poniżej 0 "
        }
    }

    static getEventsToSelect(eventsToShow){
        let eventsToSelect = []

        eventsToShow.forEach(eventType =>{
            if(!EVENTS.includes(eventType)){
                return
            }

            eventsToSelect.push({
                'name' : this.getEventName(eventType),
                'value': eventType
            })
        })

        return eventsToSelect
    }
}